<template>
    <div class="sn">

        <div class="swiper_box">
            <el-carousel height="370px" indicator-position="none" autoplay>
                <el-carousel-item v-for="(item, index) in NewsList" :key="index">
                    <div class="sw-item" style="" @click="showNewsDetail( item )">
                            <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1"  alt="">
                            <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1"  alt="">
                            <div class="news_title ">
                                {{ item.news_title }}
                            </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="news_list">
            <div class="news_title">
                <div class="left">
                    政策解读
                </div>
                <div class="more" @click="showMore">
                    更多 >
                </div>
            </div>
            <div class="news_box">
                <div class="news_item hvr-forward" v-for="(item, index) in NewsList" :key="index" @click="showNewsDetail(item)">
                    <div class="news_titles">
                        {{ item.news_title }}
                    </div>
                    <div class="time_box">
                        {{ item.create_time }}
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                NewsList: [
                    
                ],
                cate_id: 186,
                size: 7,
            }
        },
        mounted () {
            this.getNewsList();
        },
        methods: {
            // 获取新闻列表
            async getNewsList () {
                let { cate_id, size } = this 
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id, pageSize: size })
                if ( res.data.code == 1 ) {
                    this.NewsList = res.data.res
                } 
            },
            // 展示新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },
            // 更多
            showMore () {
                this.$router.push({
                    path: "/moreNewsList",
                    query: {
                        cate_id:this.cate_id,
                        isSearch:0,
                        keyword: ""
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.sn {
    width: 1200px;
    margin: 60px auto;
    display: flex;
    justify-content: space-between;
    .swiper_box {
        width: 610px;
        height: 370px;
        box-sizing: border-box;
        .sw-item {
            width:610px;height:370px;background:#fff;
            position: relative;left: 0;top: 0;
            img {
                width: 610px;
                height: 370px;
            }
            .news_title {
                width: 100%;
                height: 55px;
                line-height: 55px;
                padding-left: 20px;
                position: absolute;
                left: 0;
                bottom: 0;
                background-color: rgba(0,0,0,.3);
                color: #fff;
                @include SingleRow;
                cursor: pointer;
            }
        }
    }
    .news_list {
        width: 565px;
        height: 370px;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        .news_title {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // padding: 10px 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #d40000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            .left {
                font-size: 24px;
                color: #2767c4 ;
                font-weight: bold;
            }
            .more {
                font-size: 14px;
                color: #d3d3d3;
            }
        }
        .news_box {
            width: 100%;
            box-sizing: border-box;
            .news_item {
                width: 100%;
                display: flex;
                align-content: center;
                justify-content: space-between;
                padding: 10px 0;
                cursor: pointer;
                .news_titles {
                    width: 400px;
                    @include SingleRow;
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .time_box {
                    font-size: 14px;
                    color: #aeaeae;
                }
            }
        }
    }
}
</style>